module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "cd-transition-layer",
    class: {
      visible: _vm.isVisible
    }
  }), _c('div', {
    staticClass: "bgblackintro"
  }), _c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "animatedgradient"
  }), _c('div', {
    staticClass: "story"
  }, [_c('div', {
    staticClass: "logosection"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("@/assets/The_Story_Button.png"),
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "introsection"
  }, [_vm._v("Explore the background to Dreaming of a Jewish Christmas, including why many Jews celebrate the holiday with Chinese food, the history of Jews and Christmas, and a timeline of Jewish Christmas song writers and songs.")]), _c('hr', {
    staticClass: "lignemenu mt4"
  })]), _c('div', {
    staticClass: "contentsection"
  }, [_c('div', {
    staticClass: "menucontent ttu"
  }, [_c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "story/chow-mein"
    }
  }, [_vm._v("Why chow mein is the "), _c('br'), _vm._v(" chosen food")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "story/christmas"
    }
  }, [_vm._v("Can the jew keep christmas ?")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "story/timeline"
    }
  }, [_vm._v("A timeline of songs & songwriters")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "story/recipes"
    }
  }, [_vm._v("Recipes")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7095a392","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Story.vue
// module id = 1285
// module chunks = 1